import React,{useState} from "react"
import Layout from "../share/layout"
import { Link } from 'gatsby'
import arrow_down from '../../styles/icons/drop-down-arrow.svg'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS,INLINES} from '@contentful/rich-text-types'
import {FacebookShareButton,WhatsappShareButton,TwitterShareButton,LinkedinShareButton,TelegramShareButton,TumblrShareButton,PinterestShareButton} from "react-share";
import { useLocation } from "@reach/router"

const ArteyCultura = ({ pageContext }) => {
  const { pathname } = useLocation()
  const [menuDropdown, setMenuDropdown] = useState(false)
  const CategoriesClick = () => {
      setMenuDropdown(prevValue => !prevValue);
  }
  const RichContent = pageContext.dataSingle.childContentfulArteYCulturaContenidoRichTextNode.json; 


  const options = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node,children) => {
            return <img src={`https:${node.data.target.fields.file["en-US"].url}`} alt="Imagen del blog"/>
        },
        [INLINES.HYPERLINK]: (node) => {
            if((node.data.uri).includes("<iframe")){
                function createMarkup() { return {__html: `${node.data.uri}`}; };
                return <div className="rich-content-iframe" dangerouslySetInnerHTML={createMarkup()} />
            }else{
                return <a href={node.data.uri} target="_blank" rel="noopener noreferrer" style={{'color':'red'}}><b>{node.content[0].value}</b></a>
            }
        },
    },
    renderMark: {},
    }   

  return(
    <Layout descritpion={pageContext.dataSingle.descripcion} title={pageContext.dataSingle.titulo} subtitile={pageContext.dataSingle.descripcionEnElBlog} imgurl={pageContext.dataSingle.imagenDeLaEntrada.file.url}>
      <div>
            <div className="service">
                <div className="service-subcontainer">
                        <div className="menu-left">
                            <div style={{'height':'100px'}}>
                                <h1>+ARTE Y CU<span>LTURA</span></h1>
                            </div>
                            <div className="subtittle2">
                                <h2>{pageContext.dataSingle.titulo}</h2>
                                <p>{pageContext.dataSingle.descripcion}</p>
                                <h4>{pageContext.dataSingle.descripcionEnElBlog}</h4>
                                <div className="horizontal_line"></div>
                                <h5 className="text-center">Comparte</h5>
                                <div className="share-button-container">
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('FacebookShareButton').click()}><i className="fa fa-facebook"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('WhatsappShareButton').click()}><i className="fa fa-whatsapp"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('TwitterShareButton').click()}><i className="fa fa-twitter"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('LinkedinShareButton').click()}><i className="fa fa-linkedin"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('TelegramShareButton').click()}><i className="fa fa-telegram"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('TumblrShareButton').click()}><i className="fa fa-tumblr"></i></button>
                                    <button aria-label="compartir" className="share-button-style" onClick={() => document.getElementById('PinterestShareButton').click()}><i className="fa fa-pinterest"></i></button>
                                </div>


                                <FacebookShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="FacebookShareButton"/>
                                <WhatsappShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="WhatsappShareButton"/>
                                <TwitterShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="TwitterShareButton"/>
                                <LinkedinShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="LinkedinShareButton"/>
                                <TelegramShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="TelegramShareButton"/>
                                <TumblrShareButton url={`https://cultural.upc.edu.pe${pathname}`} id="TumblrShareButton"/>
                                <PinterestShareButton media={pageContext.dataSingle.imagenDeLaEntrada.file.url} url={`https://cultural.upc.edu.pe/arteycultura/color-y-sentimiento`} id="PinterestShareButton"/>
                                {
                                    pageContext.dataSingle.lista.map((lista,i) => (
                                        
                                        <div key={1560+i}>
                                            {(lista.includes(':') && i !== 0 ) ? <><h3 className="mt-2">{lista}</h3></> : <h3>{lista}</h3> }
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                </div>
                <div className="container service-container">
                    <div className="title_responsive">
                        <h1>+ARTE Y CULTURA</h1>
                        <p>Visita y descubre experiencias, eventos y noticias de contenido artístico-cultural.</p>
                    </div>
                    <div className="section-header">
                        <nav className="navigation">
                            <ul className="mainmenu">
                                <li onClick={CategoriesClick} tabIndex={-42} key={1} role='presentation'><h1>CATEGORÍAS
                                    <img src={arrow_down} alt="flecha hacia abajo"/></h1>
                                    <ul className={"submenu"+ (menuDropdown ? ' listactive' : '')}>
                                        <li><Link to={"/artesaudiovisuales"}>Artes audiovisuales</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/artesescenicas"}>Artes escénicas</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/artesplasticas"}>Artes plásticas</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/creacionliteraria"}>Creación literaria</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/disenoyartesvisuales"}>Diseño y artes visuales</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/musicaycreacionsonora"}>Música y creación sonora</Link><div className="hr_submenu"></div></li>
                                        <li><Link to={"/patrimonio"}>Patrimonio</Link><div className="hr_submenu"></div></li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>

                    </div>
                    <div className="about wow fadeInUp" data-wow-delay="0.1s">
                        <div className="container">
                            <div className="row mb-5 row-responsive-desktop">
                                <div className="blog-text">
                                    {documentToReactComponents(RichContent,options)}
                                </div>
                            </div>
                            <div className="row row-responsive-phone mt-4">
                                <div className="col-lg-12 col-md-12 responsive-text">
                                    <div className="about-text">
                                        <h2>{pageContext.dataSingle.titulo}</h2>
                                        <p>{pageContext.dataSingle.descripcion}</p>
                                        <h4>{pageContext.dataSingle.descripcionEnElBlog}</h4>
                                        <div className="horizontal_line"></div>
                                        <h5 className="comparte-text">Comparte</h5>
                                        <div className="share-button-container mb-3">
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('FacebookShareButton').click()}><i className="fa fa-facebook"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('WhatsappShareButton').click()}><i className="fa fa-whatsapp"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('TwitterShareButton').click()}><i className="fa fa-twitter"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('LinkedinShareButton').click()}><i className="fa fa-linkedin"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('TelegramShareButton').click()}><i className="fa fa-telegram"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('TumblrShareButton').click()}><i className="fa fa-tumblr"></i></button>
                                            <button className="share-button-style" aria-label="compartir" onClick={() => document.getElementById('PinterestShareButton').click()}><i className="fa fa-pinterest"></i></button>
                                        </div>

                                        {
                                            pageContext.dataSingle.lista.map((lista,i) => (
                                                <div key={1560+i}>
                                                    {(lista.includes(':') && i !== 0 ) ? <><h3 className="mt-2">{lista}</h3></> : <h3>{lista}</h3> }
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="mt-4">
                                        <div className="blog-text">
                                            {documentToReactComponents(RichContent,options)}
                                        </div>
                                    </div>

                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}
export default ArteyCultura
